import { components } from 'react-select'

import SingleValue from './SingleValue'

const CustomOption = (props) => (
  <components.Option {...props}>
    <SingleValue {...props} />
  </components.Option>
)

export default CustomOption
